import { Injectable } from '@angular/core'
import { SwPush } from '@angular/service-worker'

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {
  private readonly VAPID_PUBLIC_KEY = 'YOUR_PUBLIC_VAPID_KEY'

  constructor(private swPush: SwPush) {}

  requestSubscription() {
    if (this.swPush.isEnabled) {
      this.swPush
        .requestSubscription({
          serverPublicKey: this.VAPID_PUBLIC_KEY
        })
        .then(subscription => {
          console.log('Push Subscription:', subscription)
          // Send subscription to the backend to store it
        })
        .catch(err => console.error('Could not subscribe to notifications', err))
    }
  }
}
